<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="节点名称">
              <a-input placeholder="请输入节点名称" v-model="queryParam.nodeName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="节点编码">
              <a-input placeholder="请输入节点编码" v-model="queryParam.nodeCode"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="节点表">
                <a-input placeholder="请输入节点表" v-model="queryParam.nodeTable"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('树型页面配置')">导出</a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query
        :fieldList="superFieldList"
        ref="superQueryModal"
        @handleSuperQuery="handleSuperQuery"
      ></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down"/></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width:80px;font-size: 12px;font-style: italic;"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="handleAddSub(record)">添加下级</a>
        </span>
      </a-table>
    </div>

    <common-treeview-config-modal ref="modalForm" @ok="modalFormOk"></common-treeview-config-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import CommonTreeviewConfigModal from './modules/CommonTreeviewConfigModal'

export default {
  name: 'CommonTreeviewConfigList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    CommonTreeviewConfigModal
  },
  data() {
    return {
      description: '树型页面配置管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '节点名称',
          align: 'center',
          sorter: true,
          dataIndex: 'nodeName'
        },
        {
          title: '节点编码',
          align: 'center',
          sorter: true,
          dataIndex: 'nodeCode'
        },
        {
          title: '节点表',
          align: 'center',
          sorter: true,
          dataIndex: 'nodeTable'
        },
        {
          title: 'key字段',
          align: 'center',
          sorter: true,
          dataIndex: 'keyCol'
        },
        {
          title: 'title字段',
          align: 'center',
          sorter: true,
          dataIndex: 'titleCol'
        },
        {
          title: '父节点字段',
          align: 'center',
          sorter: true,
          dataIndex: 'parentCol'
        },
        {
          title: '父ID',
          align: 'center',
          sorter: true,
          dataIndex: 'pid'
        },
        {
          title: '是否生效',
          align: 'center',
          sorter: true,
          dataIndex: 'enabled'
        },
        {
          title: '节点页面路由',
          align: 'center',
          dataIndex: 'viewRoute'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/custom/treeview/list',
        delete: '/custom/treeview/delete',
        deleteBatch: '/custom/treeview/deleteBatch',
        exportXlsUrl: '/custom/treeview/exportXls',
        importExcelUrl: 'custom/treeview/importExcel'
      },
      dictOptions: {},
      superFieldList: []
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    handleAddSub(record) {
      this.subExpandedKeys = []
      this.getExpandKeysByPid(record.id, this.dataSource, this.dataSource)
      this.$refs.modalForm.subExpandedKeys = this.subExpandedKeys
      this.$refs.modalForm.title = '添加子分类'
      this.$refs.modalForm.edit({ pid: record.id })
      this.$refs.modalForm.disableSubmit = false
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'nodeName', text: '节点名称', dictCode: '' })
      fieldList.push({ type: 'string', value: 'nodeCode', text: '节点编码', dictCode: '' })
      fieldList.push({ type: 'string', value: 'nodeTable', text: '节点表', dictCode: '' })
      fieldList.push({ type: 'string', value: 'keyCol', text: 'key字段', dictCode: '' })
      fieldList.push({ type: 'string', value: 'titleCol', text: 'title字段', dictCode: '' })
      fieldList.push({ type: 'string', value: 'parentCol', text: '父节点字段', dictCode: '' })
      fieldList.push({ type: 'string', value: 'pid', text: '父ID', dictCode: '' })
      fieldList.push({ type: 'int', value: 'enabled', text: '是否生效', dictCode: '' })
      fieldList.push({ type: 'string', value: 'viewRoute', text: '节点页面路由', dictCode: '' })
      this.superFieldList = fieldList
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
